module.exports = __webpack_public_path__ + "media/images/FlexibleAnalysisPlatform-27ac1f4ca3e7d388f6bcffb6a83bac02.svg";